"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorNotSupported = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const faClock_1 = require("@fortawesome/free-solid-svg-icons/faClock");
const GenericError_1 = require("../GenericError");
function ErrorNotSupported() {
    return (jsx_runtime_1.jsx(GenericError_1.GenericError, Object.assign({ title: "Sorry!", icon: faClock_1.faClock }, { children: jsx_runtime_1.jsxs("p", { children: ["It seems like this feature isn't supported by your gateway yet. Stay tuned for updates, or feel free to contact our support crew at", ' ', jsx_runtime_1.jsx("a", Object.assign({ href: "mailto:support@yanzinetworks.com" }, { children: "support@yanzinetworks.com" }), void 0), "."] }, void 0) }), void 0));
}
exports.ErrorNotSupported = ErrorNotSupported;
//# sourceMappingURL=index.js.map